module.exports = __webpack_public_path__ + "7ebaf867ead556c93d2200b3cc72fdbd.png";